export default function getOS() {
    if (
        typeof process !== 'undefined' &&
        typeof process.env !== 'undefined' &&
        typeof process.env.OS !== 'undefined'
    ) {
        return process.env.OS;
    }

    if (typeof navigator !== 'undefined') {
        const userAgent = navigator.userAgent || navigator.vendor || '';
        const platform = navigator.platform || '';
        const maxTouchPoints = navigator.maxTouchPoints || 0;


        // Priority order
        if (/windows/i.test(userAgent)) return 'windows';
        if (/macintosh|mac os x/i.test(userAgent)) return 'mac';
        if (/android/i.test(userAgent)) return 'android';

        // Heuristic: If Linux + touch support, assume Android
        if (/linux/i.test(userAgent) && maxTouchPoints > 0) return 'android';

        if (/linux/i.test(userAgent)) return 'linux';
    }

    return 'unknown';
}
